export const SMS_NOTIFICATIONS_ENABLE_REQUEST = 'SMS_NOTIFICATIONS_ENABLE_REQUEST';
export const SMS_NOTIFICATIONS_ENABLE_SUCCESS = 'SMS_NOTIFICATIONS_ENABLE_SUCCESS';
export const SMS_NOTIFICATIONS_ENABLE_FAILURE = 'SMS_NOTIFICATIONS_ENABLE_FAILURE';

export const SMS_NOTIFICATIONS_DISABLE_REQUEST = 'SMS_NOTIFICATIONS_DISABLE_REQUEST';
export const SMS_NOTIFICATIONS_DISABLE_SUCCESS = 'SMS_NOTIFICATIONS_DISABLE_SUCCESS';
export const SMS_NOTIFICATIONS_DISABLE_FAILURE = 'SMS_NOTIFICATIONS_DISABLE_FAILURE';

export const SMS_PROVIDER_UPDATE_REQUEST = 'SMS_PROVIDER_UPDATE_REQUEST';
export const SMS_PROVIDER_UPDATE_SUCCESS = 'SMS_PROVIDER_UPDATE_SUCCESS';
export const SMS_PROVIDER_UPDATE_FAILURE = 'SMS_PROVIDER_UPDATE_FAILURE';
